export interface TransportMethod {
  transportMethodCode: string;
  transportMethodDesc: string;
  transportMethodId: number;
}
